module.exports = __webpack_public_path__ + "static/media/nestje3.350d3547.jpg";